<div [class]="contentPadding === true ? 'ion-padding-horizontal expandable-content w-100' : 'expandable-content w-100'">
    <div style="display: flex; align-items: center;" class="w-100">
        <app-button (click)="onExpanded()" *ngIf="expanded" [withMargin]="false" size="small"
                    [withPadding]="false" class="ion-no-margin ion-margin-end" iconName="chevron-down"></app-button>
        <app-button (click)="onExpanded()" *ngIf="!expanded" [withMargin]="false" size="small"
                    [withPadding]="false" class="ion-no-margin ion-margin-end" iconName="chevron-right"></app-button>
        <div class="expandable-content-title" style="flex-grow: 1;">
            <ng-content select="[title]"></ng-content>
            <span *ngIf="title" style="font-size: 12px;">{{title}}</span>
        </div>
        <div class="flex-grow-0">
            <ng-content select="[header-button]"></ng-content>
        </div>
    </div>
    <ng-container *ngIf="expanded">
        <ng-container *ngIf="expandedContentTemplate; else plainProjection">
            <ng-container *ngTemplateOutlet="expandedContentTemplate"></ng-container>
        </ng-container>
        <ng-template #plainProjection>
            <ng-content></ng-content>
        </ng-template>
    </ng-container>
</div>
